var image_viewer_default = {
  "fontElementMap": "xtNc-",
  "imageContainer": "BQeci",
  "expandButton": "oTgCg",
  "expandIcon": "wT5LN",
  "pointer": "M4sqQ",
  "imageWrapper": "OfQ-9",
  "imageRatio": "nf1pR",
  "image": "N7MnT",
  "imageOverlay": "Dq-z-",
  "imagePreload": "do-Hb",
  "imageHighres": "_3ESmb",
  "onlyHighRes": "zzOHC",
  "image_loading": "gReVq"
};
export {
  image_viewer_default as default
};
//# sourceMappingURL=image-viewer-scss.js.map
